import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Text } from '@ui/lib/park/ui/text';
import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';
import { useTranslation } from 'next-i18next';

import { labelStyle, valueStyle } from './styles';

export const EntryPrice = ({ position }: { position: Position }) => {
  const { t } = useTranslation();

  const priceDisplayDecimals = useTokenDisplayDecimals(
    position?.pair.baseSymbol,
    position?.pair.priceDisplayDecimals,
  );

  return (
    <>
      <Text css={labelStyle}>{t('common.Entry Price')}</Text>
      <AmountUsd
        value={position.entryPrice}
        css={valueStyle}
        opts={{
          displayDecimals: priceDisplayDecimals,
        }}
        data-cy="EntryPrice"
        data-cy-value={position.entryPrice}
      />
    </>
  );
};
